import { Icon } from "@mdi/react";
import React from "react";
import { useSelector } from "react-redux";

import { mdiContentCopy } from "@mdi/js";
import { RootState } from "store/rootReducer";

import { SetFocusPayload, SettingsProps } from "components/automation/types/payloads";

import { StyledContainer, StyledCopyButton, StyledLabelValue } from "./shared";

export const SetFocusSettings: React.FC<SettingsProps<SetFocusPayload>> = ({
  value,
  onChange
}) => {
  const globalGroupBy = useSelector((state: RootState) => state.groupBy.globalGroupBy);

  return (
    <StyledContainer>
      <StyledCopyButton
        size="large"
        icon={<Icon path={mdiContentCopy} size={1.2} />}
        onClick={() => onChange(globalGroupBy)}>
        Copy Current Group By
      </StyledCopyButton>
      <StyledLabelValue>
        <span className="label">Title:</span>
        <span className="value">{value?.title || "No group by selected"}</span>
      </StyledLabelValue>
      <StyledLabelValue>
        <span className="label">Entity Kind:</span>
        <span className="value">{value?.entityKind || ""}</span>
      </StyledLabelValue>
      {value?.product && (
        <StyledLabelValue>
          <span className="label">Product:</span>
          <span className="value">{value.product}</span>
        </StyledLabelValue>
      )}
      {value?.group && (
        <StyledLabelValue>
          <span className="label">Group:</span>
          <span className="value">{value.group}</span>
        </StyledLabelValue>
      )}
    </StyledContainer>
  );
};
